module.exports = __webpack_public_path__ + "static/media/Linkedin-Logo.4fb669e6.svg";